module.exports = __webpack_public_path__ + "static/img/institute.a0ef2f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institute/pic/institute.jpg
// module id = fdnB
// module chunks = 11